import type { Template } from "@/types";

export const LA_06_H5_V1: Template[] = [
    {
        id: "la-06-h5v1-01",
        name: "LA 01 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 77, y: 45, width: 208, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 194, width: 208, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 77, y: 344, width: 208, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 293, y: 45, width: 305, height: 440, rotation: 0, imageRotation: 0 },
            { id: "5", x: 842, y: 45, width: 344, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 842, y: 270, width: 344, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-02",
        name: "LA 02 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 110, y: 45, width: 295, height: 440, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 45, width: 144, height: 104, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 157, width: 144, height: 104, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 269, width: 144, height: 104, rotation: 0, imageRotation: 0 },
            { id: "5", x: 412, y: 381, width: 144, height: 104, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 105, width: 493, height: 320, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-03",
        name: "LA 03 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 89, y: 85, width: 246, height: 361, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 85, width: 245, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 270, width: 245, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 55, width: 420, height: 274, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 337, width: 206, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 337, width: 206, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-04",
        name: "LA 04 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 157, y: 37, width: 336, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 157, y: 259, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 157, y: 381, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 259, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 381, width: 164, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 849, y: 37, width: 330, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-05",
        name: "LA 05 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 71, y: 80, width: 535, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 806, y: 51, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 197, width: 204, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 343, width: 204, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 343, width: 204, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 51, width: 204, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-06",
        name: "LA 06 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 62, y: 93, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 269, width: 238, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 308, y: 93, width: 237, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 308, y: 269, width: 237, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 553, y: 93, width: 214, height: 343, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 93, width: 516, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-07",
        name: "LA 07 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 61, y: 93, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 269, width: 238, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 93, width: 214, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 93, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 529, y: 269, width: 238, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 93, width: 516, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-08",
        name: "LA 08 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 61, y: 93, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 269, width: 238, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 93, width: 214, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 93, width: 516, height: 343, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1053, y: 93, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1053, y: 269, width: 238, height: 167, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-09",
        name: "LA 09 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 50, y: 42, width: 297, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 42, width: 274, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 320, width: 274, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 354, y: 222, width: 134, height: 90, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 222, width: 133, height: 90, rotation: 0, imageRotation: 0 },
            { id: "6", x: 635, y: 42, width: 668, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-10",
        name: "LA 10 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 107, y: 42, width: 158, height: 107, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 157, width: 158, height: 106, rotation: 0, imageRotation: 0 },
            { id: "3", x: 107, y: 271, width: 158, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 107, y: 385, width: 158, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 273, y: 42, width: 296, height: 449, rotation: 0, imageRotation: 0 },
            { id: "6", x: 577, y: 42, width: 668, height: 449, rotation: 0, imageRotation: 0 }
        ],
    }
];